// Klartext-Check Subscription Plans
export type KlartextPlan = 'free' | 'pro' | 'familie' | 'firma';

export interface PlanDetails {
  id: KlartextPlan;
  name: string;
  price: number; // in cents
  priceFormatted: string;
  features: string[];
  checksPerMonth: number | 'unlimited';
  popular?: boolean;
}

export const KLARTEXT_PLANS: Record<KlartextPlan, PlanDetails> = {
  free: {
    id: 'free',
    name: 'Kostenlos',
    price: 0,
    priceFormatted: '0 €',
    features: [
      '3 Checks einmalig kostenlos',
      'Text & Bild-Analyse',
      'Sofortige Ergebnisse',
    ],
    checksPerMonth: 3,
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    price: 900,
    priceFormatted: '9 €/Monat',
    features: [
      'Unbegrenzte Checks',
      'Check-Historie speichern',
      'Detaillierte Analysen',
      'Prioritäts-Support',
    ],
    checksPerMonth: 'unlimited',
    popular: true,
  },
  familie: {
    id: 'familie',
    name: 'Familie',
    price: 500,
    priceFormatted: '5 €/Monat',
    features: [
      'Unbegrenzte Checks',
      '2 Familien-Accounts',
      'Check-Historie speichern',
      'E-Mail-Support',
    ],
    checksPerMonth: 'unlimited',
  },
  firma: {
    id: 'firma',
    name: 'Firma',
    price: 2900,
    priceFormatted: '29 €/Monat',
    features: [
      'Unbegrenzte Checks',
      'Bis zu 10 Mitarbeiter',
      'Check-Historie speichern',
      'Priority-Support',
      'Monatlicher Sicherheitsreport',
    ],
    checksPerMonth: 'unlimited',
  },
};

// Total limit for free users (one-time, not daily)
export const FREE_TOTAL_LIMIT = 3;

// Storage key for anonymous usage tracking
export const USAGE_STORAGE_KEY = 'klartext-check-usage';

export interface UsageData {
  count: number; // Total count (not daily anymore)
}

export function getTotalUsage(): UsageData {
  const stored = localStorage.getItem(USAGE_STORAGE_KEY);
  
  if (stored) {
    const data = JSON.parse(stored);
    // Handle migration from old format (with date) to new format (total only)
    if (typeof data.count === 'number') {
      return { count: data.count };
    }
  }
  
  return { count: 0 };
}

export function incrementUsage(): UsageData {
  const current = getTotalUsage();
  const updated = { count: current.count + 1 };
  localStorage.setItem(USAGE_STORAGE_KEY, JSON.stringify(updated));
  return updated;
}

export function getRemainingChecks(): number {
  const usage = getTotalUsage();
  return Math.max(0, FREE_TOTAL_LIMIT - usage.count);
}

export function canPerformCheck(): boolean {
  return getRemainingChecks() > 0;
}
